import { Switch } from '@headlessui/react';
import { cx, css } from '@linaria/core';
import { IconData } from 'components/Icons';
import { TooltipWrapper } from 'modules/Playground/Components/TooltipWrapper';
interface StreamingToggleProps {
  isEnabled: boolean;
  onChange: () => void;
  tooltipText: string | JSX.Element;
  hide?: boolean;
}
export const StreamingToggle: React.FC<StreamingToggleProps> = ({
  isEnabled,
  onChange,
  tooltipText,
  hide
}) => {
  if (hide) return null;
  return <TooltipWrapper toolTipText={tooltipText} side="right">
      <div className={styles.switchContainer}>
        <Switch checked={isEnabled} onChange={onChange} className={cx(styles.switchBase, isEnabled ? styles.switchEnabled : styles.switchDisabled)}>
          <span className={cx(styles.switchThumb, isEnabled && styles.switchThumbEnabled)} />
        </Switch>
        <IconData color="#475467" />
      </div>
    </TooltipWrapper>;
};
export const styles = {
  switchContainer: "odules__Playground__Components__StreamingToggle__StreamingToggle_tsx-switchContainer-s113lfqz",
  switchBase: "odules__Playground__Components__StreamingToggle__StreamingToggle_tsx-switchBase-s5koy9h",
  switchEnabled: "odules__Playground__Components__StreamingToggle__StreamingToggle_tsx-switchEnabled-s17zkh76",
  switchDisabled: "odules__Playground__Components__StreamingToggle__StreamingToggle_tsx-switchDisabled-sgf6bo4",
  switchThumb: "odules__Playground__Components__StreamingToggle__StreamingToggle_tsx-switchThumb-s14ajsu8",
  switchThumbEnabled: "odules__Playground__Components__StreamingToggle__StreamingToggle_tsx-switchThumbEnabled-scq8eyi"
};

require("./StreamingToggle.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./StreamingToggle.tsx");